export default __webpack_public_path__ + "static/media/accueil.2f1695e3.png";